/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from 'react';
import { Outlet } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { PopModal } from '../components/PopModal';
import '../css/style.css';
import { ErrorAlertModal } from '../components/ErrorAlertModal';


export default class Outside extends React.Component {

    render() {
        return (
            <>
                <ToastContainer position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light" />
                <PopModal />
                <Outlet />
                <ErrorAlertModal />
            </>
        );
    }
}